// Wire format of the `@mention` chip family; the editor's prop types stay in `@quovy/ui`.

/**
 * Node type name persisted in stored Tiptap JSON for mention chips, and the
 * JSON attribute key holding the mention's type. Task comments written before
 * this surface moved onto the shared chip editor serialize exactly these names
 * — do not rename them.
 */
export const MENTION_NODE = "mention";
export const MENTION_TYPE_ATTR = "mentionType";

/** The kind of entity being mentioned. */
export type MentionableType = "user" | "agent" | "tool";

/**
 * Infer the mentionable type from an entity ID.
 * Falls back to "user" when no prefix matches.
 */
export function inferMentionableType(id: string): MentionableType {
  if (id.startsWith("agt_")) return "agent";
  if (id.startsWith("tool:")) return "tool";
  return "user";
}

/** Shape of a Tiptap JSON node for server-side utilities. */
export interface JSONContent {
  type?: string;
  attrs?: Record<string, unknown>;
  content?: JSONContent[];
  text?: string;
  marks?: Mark[];
}

export interface Mark {
  type: string;
  attrs?: Record<string, unknown>;
}
